__webpack_require__.p = "https://oss-assets.amberstudent.cn/amber-user-website/VP1-8.54.8-7c66-amber-user-website-prod-hk-1867/assets/";